/**
 * Option lists for the Text Notes Routing table (route via, response status,
 * note state, and the note sections a rule adds). Values match what the delivery
 * pipeline writes into `document_config.routing`, so they round-trip verbatim.
 * Values outside these lists (e.g. legacy "Prompt PA") still render as tags.
 * "What we add" is derived from the configured body columns rather than fixed.
 */
import { SubmissionSummaryRouteVia } from "../../../../../enums/submissionSummaryRouteVia";

const toOptions = (values: string[]) =>
  values.map((value) => ({ value, label: value }));

/** Submission route keys a routing rule can match. */
export const ROUTE_VIA_OPTIONS = toOptions(
  Object.values(SubmissionSummaryRouteVia),
);

/** PA response statuses a routing rule can match. */
export const ROUTING_RESPONSE_STATUS_OPTIONS = toOptions([
  "Approved",
  "Approval on File",
  "Auth Not Required",
  "Denied",
  "Denial on File",
  "Drug Not Covered",
  "Pending",
  "NA Outcome",
  "Onshore Assistance",
  "Send To Client",
]);

/* "What we add" options are derived per-org from the body columns; see
   textNotesWhatWeAddOptions.ts. */

/** Note state a rule produces. */
export const NOTE_STATE_OPTIONS = [
  { value: "signed", label: "Signed" },
  { value: "unsigned", label: "Unsigned" },
  { value: "manual", label: "Manual" },
];

/** Pill colours per note state, keyed for the PILL_SELECT cell `styleMap`. */
export const NOTE_STATE_STYLE_MAP: Record<string, string> = {
  signed: "bg-green-50 text-green-700 border-green-200",
  unsigned: "bg-amber-50 text-amber-700 border-amber-200",
  manual: "bg-blue-50 text-blue-700 border-blue-200",
};
